/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { getPages } from '../../contentful/page-lookup';
import UnbulletedList from '../styles/unbulleted-list';
import {
  NavContainer, NavBuckets, Bucket, NavLink, SectionLink, SinglePageBucket, SinglePageContainer,
} from './site-navigation-css';

export const SiteNavigation = ({ singlePages }) => {
  const pages = getPages();
  const rootPage = pages.tree[0];

  return (
    <NavContainer>
      <NavBuckets>
        {rootPage.children.map(({ title, path, children }) => (
          <Bucket key={path}>
            <li>
              <SectionLink to={path}>{title}</SectionLink>
              {children.length > 0 && (
                <UnbulletedList>
                  {children.map((child) => (
                    <li key={child.path}><NavLink to={child.path}>{child.title}</NavLink></li>
                  ))}
                </UnbulletedList>
              )}
            </li>
          </Bucket>
        ))}
      </NavBuckets>
      { /* {singlePages && singlePages.length > 0 && (
        <SinglePageBucket>
          {singlePages.map(({ title, slug }) => (
            <SinglePageContainer key={slug}>
               <SectionLink to={`/${slug}`}>{title}</SectionLink>
            </SinglePageContainer>
          ))}
        </SinglePageBucket>
      )} */ }
    </NavContainer>
  );
};

SiteNavigation.propTypes = {
  singlePages: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })),
};

SiteNavigation.defaultProps = {
  singlePages: null,
};

const SiteNavigationWithQuery = (props) => {
  const { contentfulNavigation } = useStaticQuery(graphql`
    query {
      contentfulNavigation(title: {eq: "Footer single pages"}) {
        links {
          title
          slug
        }
      }
    }
  `);

  return (
    <SiteNavigation
      singlePages={contentfulNavigation ? contentfulNavigation.links : null}
      {...props}
    />
  );
};

export default SiteNavigationWithQuery;
